/**
 * 截屏保护桥（阶段二）：原生 Android 经 Capacitor ScreenGuard 插件切换 FLAG_SECURE，
 * Web 环境 no-op。插件为 MainActivity 注册的原生插件（@CapacitorPlugin(name="ScreenGuard")），
 * 走原生桥全局 Capacitor.nativePromise 直调（不依赖 @capacitor/core，apps/web 零新增依赖）。
 */
interface CapacitorGlobal {
  isNativePlatform?: () => boolean;
  /** 原生桥 Promise 调用（native-bridge.js 注入） */
  nativePromise?: (pluginId: string, methodName: string, options?: Record<string, unknown>) => Promise<unknown>;
  [key: string]: unknown;
}

function capacitor(): CapacitorGlobal | null {
  return (globalThis as { Capacitor?: CapacitorGlobal }).Capacitor ?? null;
}

/** 是否原生 App 环境 */
export function isNativeApp(): boolean {
  try {
    return capacitor()?.isNativePlatform?.() === true;
  } catch {
    return false;
  }
}

/**
 * 设置截屏保护：protected=true → 禁止截屏/录屏/最近任务缩略图（Android FLAG_SECURE）。
 * 非原生环境静默 no-op；原生插件缺失时仅告警不抛出。
 */
export async function setScreenProtected(protectedOn: boolean): Promise<void> {
  const cap = capacitor();
  if (!isNativeApp() || typeof cap?.nativePromise !== 'function') return;
  try {
    await cap.nativePromise('ScreenGuard', 'setProtected', { on: protectedOn });
  } catch (e) {
    // 插件缺失/桥异常不阻断业务（原生侧 MainActivity 启动默认已加 FLAG_SECURE）
    console.warn('[screenGuard] setProtected 失败：', e);
  }
}
